module.exports = __webpack_public_path__ + "media/images/front/content/img01-98d63da5fcb6b7f687fb32e5c1c3bd84.png";